import HttpCliente from "../servicios/HttpCliente";

export const insertarOperacion = async (payload) => {
    return await HttpCliente.post("/Operaciones", payload);
};

export const actualizarOperacion = async (payload) => {
    return await HttpCliente.put("/Operaciones", payload);
};

export const obtenerOperacion = async () => {
    return await HttpCliente.get("/Operaciones");
};